import axios from 'axios'

export class AvailabilityApi {
    static async indexAsAdmin(applicantId, params) {
        const response = await axios.get(route('api.admin.applicant.availability.index', { applicant: applicantId }), {
            params,
        })
        return response.data
    }

    static async indexAsBackoffice(applicantId, params) {
        const response = await axios.get(
            route('api.backoffice.applicant.availability.index', { applicant: applicantId }),
            { params }
        )
        return response.data
    }

    static async indexAsApplicant(params) {
        const response = await axios.get(route('api.applicant.availability.index'), { params })
        return response.data
    }

    static async destroyAsAdmin(applicantId, availabilityId) {
        const response = await axios.delete(
            route('api.admin.applicant.availability.destroy', {
                applicant: applicantId,
                availability: availabilityId,
            })
        )
        return response.data
    }

    static async destroyAsApplicant(availabilityId) {
        const response = await axios.delete(
            route('api.applicant.availability.destroy', {
                availability: availabilityId,
            })
        )
        return response.data
    }
}
